import { useMutation, useQueryClient } from "react-query";
import { deleteCarrierProgram } from "../../../../../actions/Utilities/CarrierProgram";
import { toast } from "../../../../../components/toastNotification";

const useDeleteCarrierProgram = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation((ids) => deleteCarrierProgram(ids), {
    onSuccess: (res) => {
      if (res) {
        if (res.status === 201) {
          queryClient.invalidateQueries("GetCarrierPrograms");
          toast.fire(
            "Success",
            "Carrier Program has been deactivated successfully",
            "success"
          );
        } else {
          toast.fire(
            "Failed",
            "Failed to deactivate Carrier Program",
            "error"
          );
        }
      } else {
        toast.fire("Failed", "Failed to deactivate Carrier Program", "error");
      }
    },
    onError: () => {
      toast.fire(
        "Failed",
        "Server Error: Cannot deactivate Carrier Program",
        "error"
      );
    },
  });

  return mutate;
};
export default useDeleteCarrierProgram;
